export default {"src":"/statics/ecommerce/_next/static/media/big-discount-info.ce41b4d2.svg","height":16,"width":38,"blurWidth":0,"blurHeight":0};